<template>
  <div class="event" style="width:100%">
    <div class="user-header">
        <button @click="back" type="button" class="button primary block">
          <svg x="0px" y="0px" width="42px" height="42px" viewBox="0 0 42 42" xml:space="preserve"> <polygon fill-rule="evenodd" points="27.066,1 7,21.068 26.568,40.637 31.502,35.704 16.865,21.068 32,5.933 "/> </svg>
          Geri Dön</button>
        <div>
          <p>{{ $store.getters['getClientMeta'].name }}</p>
          <h3 class="line-title">Mesaj Oluştur</h3>
        </div>
    </div>
    <div class="user-content-inc fluid">
        <div class="panel no-title">
            <div class="title" v-if="!isMobile">Talep Oluşturun</div>
            <div class="content">
                <form @submit.prevent="create">
                    <div class="row">
                      <div class="col">
                          <div class="inline-form">
                            <label>Konu</label>
                            <input type="text" v-model="form.subject" placeholder="Adınızı yazınız">
                          </div>
                      </div>
                      <div class="col">
                          <div class="inline-form">
                            <label>Departman</label>
                            <select v-model="form.department">
                              <option disabled :value="null">Seçiniz</option>
                              <option value="finance">Finansal</option>
                              <option value="ads">Reklam</option>
                              <option value="coupon">Kupon</option>
                              <option value="casino">Casino</option>
                              <option value="suggestion">Öneri / Şikayet</option>
                              <option value="other">Diğer</option>
                            </select>
                          </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="inline-form">
                          <textarea placeholder="Mesajiniz" v-model="form.message" cols="20" rows="6"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col" :class="{' justify-flex-end' : !isMobile}">
                          <ButtonLoader class="primary" :class="{'block' : isMobile}" :loader="btnLoading" :text="'Mesajı Gönder'" />
                      </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
  </div>
</template>
<style scoped>
  button{
    font-weight: bold;
    width: 150px;
    height: 45px;
  }
</style>
<script>
  import Header from '../../Common/User/Header'
  export default{
    data(){
      return{
        form:{
          subject:null,
          department:null,
          message: null,
        },
        btnLoading: false,
      }
    },
    components:{
      Header
    },
    methods:{
      create(){
          this.btnLoading = true;
          axios.post('/user/tickets', { ...this.form })
          .then((response)=>{
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
            this.back();
          })
          .catch(() => {})
          .finally(() => {
            this.btnLoading = false;
          });
      },
      back(){
        this.$emit('CreateTicket', false);
      }
    }
  }
</script>